const LABELS = {
  ambientes: "Ambientes",
  dormitorios: "Dormitorios",
  "baños": "Baños",
  plantas: "Plantas",
  patio: "Patio",
  expensas: "Expensas",
  estado: "Estado",
  contrato: "Contrato",
};

// Claves numéricas: "6" + "Ambientes" -> "6 Ambientes"
const NUMERIC_KEYS = new Set(["ambientes", "dormitorios", "baños", "plantas"]);
// Claves Sí/No: se leen como "Con patio" / "Sin patio" en vez de "Si patio"
const BOOLEAN_KEYS = new Set(["patio", "expensas"]);

const toTitleCase = (str) =>
  String(str || "").trim().replace(/\b\w/g, (c) => c.toUpperCase());

export const isNumericCharacteristic = (key) => NUMERIC_KEYS.has(key);

export const isBooleanCharacteristic = (key) => BOOLEAN_KEYS.has(key);

export const isAffirmative = (value) => /^s(i|í)$/i.test(String(value ?? "").trim());

export const characteristicLabel = (key) => LABELS[key] || toTitleCase(key);

// Claves que son datos administrativos (no para mostrar al público en un
// cartel de vidriera): estado de conservación y duración del contrato.
export const isAdminCharacteristic = (key) => key === "estado" || key === "contrato";

// Arma un texto legible para una característica de la propiedad (clave +
// valor crudo guardado en el formulario), en vez de concatenar valor y clave
// tal cual (lo que da frases como "no contrato" o "Si patio").
export function formatCharacteristic(key, rawValue) {
  const label = LABELS[key] || toTitleCase(key);
  const value = String(rawValue ?? "").trim();

  if (NUMERIC_KEYS.has(key)) {
    return `${value} ${label}`;
  }
  if (BOOLEAN_KEYS.has(key)) {
    const esAfirmativo = /^s(i|í)$/i.test(value);
    return esAfirmativo ? `Con ${label.toLowerCase()}` : `Sin ${label.toLowerCase()}`;
  }
  return `${label}: ${toTitleCase(value)}`;
}
